import { render, staticRenderFns } from "./BirthForm.vue?vue&type=template&id=d16b42ae"
import script from "./BirthForm.vue?vue&type=script&lang=js"
export * from "./BirthForm.vue?vue&type=script&lang=js"
import style0 from "./BirthForm.vue?vue&type=style&index=0&id=d16b42ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports